import { InjectionToken } from '@angular/core';
import { SocketIoConfig } from './socket-io.config';

export const SOCKET_CONFIG_TOKEN = new InjectionToken<SocketIoConfig>(
  '__SOCKET_IO_CONFIG__'
);
